import React, { useCallback, useState } from 'react'
import { isEmptyString } from '../../../../utils/string-utils'
import { IconButton, Tooltip } from '@mui/material'
import PlainModal from '../../../../components/modal/plain-modal'
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors'

export interface RiskModalTriggerProps {
  strategyName: string
  isApiConnected: boolean
  riskUrl: string | null
}

const RiskModalTrigger: React.FC<RiskModalTriggerProps> = (props) => {
  const { strategyName, isApiConnected, riskUrl } = props
  const isDisabled = !isApiConnected || isEmptyString(riskUrl)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const openModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <PlainModal
        open={isModalOpen}
        onClose={closeModal}
        title={`${strategyName} Risk`}
        dataUrl={riskUrl}
      />

      <Tooltip title='View risk'>
        <span>
          <IconButton size='small' disabled={isDisabled} onClick={openModal}>
            <RunningWithErrorsIcon/>
          </IconButton>
        </span>
      </Tooltip>
    </>
  )
}

export default React.memo(RiskModalTrigger)
